import WithTooltip from './with-tooltip-hoc';

export default WithTooltip;
